var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "btn-group float-end" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        class: [
          "dropdown-menu sip-sort-menu",
          _vm.getConfig("direction") == "ltr" ? "dropdown-menu-right" : "",
        ],
        attrs: { "aria-labelledby": "sortByLink" },
      },
      [
        _vm._l(_vm.sortByOptions, function (option) {
          return _c(
            "button",
            {
              key: "order-" + option.value,
              staticClass: "dropdown-item custom-dropdown sip-sort-item",
              on: {
                click: function ($event) {
                  return _vm.$emit("updateOrder", option.value)
                },
              },
            },
            [
              _c(
                "span",
                {
                  staticClass: "sip-sort-item__icon",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("admin-icon", { attrs: { name: option.icon, size: 15 } })],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "sip-sort-item__label" }, [
                _vm._v(_vm._s(option.translation)),
              ]),
              _vm._v(" "),
              option.value == _vm.order
                ? _c(
                    "span",
                    { staticClass: "sip-sort-item__check" },
                    [_c("admin-icon", { attrs: { name: "check", size: 14 } })],
                    1
                  )
                : _vm._e(),
            ]
          )
        }),
        _vm._v(" "),
        _c("div", { staticClass: "dropdown-divider" }),
        _vm._v(" "),
        _vm._l(_vm.orderByOptions, function (option) {
          return _c(
            "button",
            {
              key: "field-" + option.value,
              staticClass: "dropdown-item custom-dropdown sip-sort-item",
              on: {
                click: function ($event) {
                  return _vm.$emit("updateSortBy", option.value)
                },
              },
            },
            [
              _c(
                "span",
                {
                  staticClass: "sip-sort-item__icon",
                  attrs: { "aria-hidden": "true" },
                },
                [
                  _c("admin-icon", {
                    attrs: { name: _vm.fieldIcon(option), size: 15 },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "sip-sort-item__label" }, [
                _vm._v(_vm._s(option.translation)),
              ]),
              _vm._v(" "),
              option.value == _vm.sortBy
                ? _c(
                    "span",
                    { staticClass: "sip-sort-item__check" },
                    [_c("admin-icon", { attrs: { name: "check", size: 14 } })],
                    1
                  )
                : _vm._e(),
            ]
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "btn btn-outline-light btn-sm btn-sort",
        attrs: {
          type: "button",
          role: "menu",
          id: "sortByLink",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false",
        },
      },
      [
        _c("em", { staticClass: "icon ni ni-sort-v" }),
        _vm._v(" "),
        _c("span", { staticClass: "d-none d-sm-inline" }, [_vm._v("Sort")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }